import { Link } from "react-router-dom";

const certifications = [
  {
    title: "AWS",
    certificateTitle: "Auditing S3 Security",
    description:
      "Auditing S3 Security bezieht sich auf die Überprüfung und Bewertung der Sicherheitskonfigurationen und -praktiken eines Amazon S3 (Simple Storage Service) Speicher-Buckets. Dabei wird untersucht, ob die gespeicherten Daten angemessen vor unbefugtem Zugriff und anderen Bedrohungen geschützt sind. Dies umfasst die Prüfung von Zugriffskontrollen, Verschlüsselungseinstellungen, Protokollierung und anderen Sicherheitsmaßnahmen, um sicherzustellen, dass die Daten sicher und konform mit den geltenden Standards und Vorschriften gespeichert werden.",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "AWS Certification Subject Matter Expert",
    description:
      "Ein AWS SME (Subject Matter Expert) ist ein Fachexperte, der umfassendes Wissen über AWS-Dienste besitzt und bei der Erstellung, Überprüfung und Aktualisierung von AWS-Zertifizierungsprüfungen mitwirkt. Diese Experten tragen dazu bei, die Relevanz und Genauigkeit der Zertifizierungsinhalte sicherzustellen.",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "Amazon S3 Cost Optimization",
    description:
      "Cost Optimization bei Amazon S3 bezieht sich auf Strategien und Best Practices, um die Kosten für die Nutzung des Amazon Simple Storage Service (S3) zu minimieren, ohne die Leistungsfähigkeit oder Sicherheit zu beeinträchtigen.",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "Amazon FSx for Windows File Server",
    description:
      "Amazon FSx for Windows File Server ist ein vollständig verwalteter Dateispeicherdienst, der die Leistung, Funktionen und Kompatibilität eines Windows File Servers bietet. Dieser Dienst übernimmt die Verwaltung und Wartung der Hardware, das Patchen des Betriebssystems und die Sicherung Ihrer Daten, was den Verwaltungsaufwand erheblich reduziert und es Ihnen ermöglicht, sich auf andere geschäftliche Aufgaben zu konzentrieren.",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "Amazon FSx for NetApp ONTAP",
    description:
      "Amazon FSx for NetApp ONTAP ist ein vollständig verwalteter Service, der die branchenführende NetApp ONTAP-Technologie auf die AWS-Cloud bringt. Dieser Dienst bietet Ihnen die Flexibilität, Performance und umfassenden Datenmanagement-Funktionen von NetApp ONTAP, kombiniert mit der Skalierbarkeit und Benutzerfreundlichkeit der AWS-Cloud.",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "Elemental MediaConvert",
    description:
      "Amazon Elemental MediaConvert ist ein hochgradig skalierbarer und vollständig verwalteter Dienst, der Ihnen die Möglichkeit bietet, Video-Inhalte für die Übertragung und On-Demand-Übertragung in verschiedenen Formaten zu transkodieren. ",
    image: "aws_logo_transparent",
    link: "",
  },
  {
    title: "AWS",
    certificateTitle: "AWS S3 Performance Optimization",
    description:
      "AWS S3 Performance Optimization bezieht sich auf Strategien und Best Practices, die dazu beitragen, die Effizienz und Geschwindigkeit von Speicheroperationen im Amazon Simple Storage Service (S3) zu maximieren.",
    image: "aws_logo_transparent",
    link: "",
  },
];

const badges = [
  {
    title: "AWS",
    certificateTitle: "AWS Knowledge: Cloud Essentials",
    description:
      "Die Träger dieses Abzeichens haben sich Kenntnisse über grundlegende AWS-Cloud-Konzepte angeeignet, wobei der Schwerpunkt auf AWS-Rechen-, Speicher-, Netzwerk- und Datenbankdiensten, Sicherheit, Architektur, Preisen und Support liegt.",
    image: "aws-knowledge-cloud-essentials",
    link: "https://www.credly.com/users/julian-leipert/badges",
  },
  {
    title: "AWS",
    certificateTitle: "AWS Partner: AWS GovCloud (US) Essentials",
    description:
      "Träger dieses neuen Badges sind AWS-Partner, die grundlegende Kenntnisse der Infrastruktur und Services von AWS GovCloud (USA) nachgewiesen haben. Der Träger kann erklären, wie der Service die Einhaltung gesetzlicher Vorschriften unterstützt, und ist in der Lage, eine Methode vorzustellen, die ihm dabei hilft, zu entscheiden, ob der Service für AWS-Kunden geeignet ist oder nicht. Träger dieses neuen Badges sind AWS-Partner, die grundlegende Kenntnisse der Infrastruktur und Services von AWS GovCloud (USA) nachgewiesen haben. Der Träger kann erklären, wie der Service die Einhaltung gesetzlicher Vorschriften unterstützt, und ist in der Lage, eine Methode vorzustellen, die ihm dabei hilft, zu entscheiden, ob der Service für AWS-Kunden geeignet ist oder nicht.",
    image: "aws-partner-aws-govcloud-us-essentials",
    link: "https://www.credly.com/users/julian-leipert/badges",
  },
];

export default function CertificationsPage() {
  return (
    <>
      <div>
        <Link className="top-40" to="/">
          <div className="sticky top-5 ml-40 pt-10">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="white"
              class="size-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m11.25 9-3 3m0 0 3 3m-3-3h7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
          </div>
        </Link>

        <div className="m-auto  max-w-max mt-6 text-center relative">
          <h2 className="text-gray-100 text-xl font-bold  uppercase tracking-wide">
            Zertifikate & Abzeichen
          </h2>
          <p className="text-gray-300 text-sx mt-8">
            Dies ist eine Sammlung von zertifikaten und anderen Annerkungen
            welche ich in meiner Freizeit erworben habe.
          </p>

          <h3 className="text-gray-300 text-lg font-bold mt-24  uppercase tracking-wide">
            AWS Abzeichen
          </h3>
          <div className=" mt-12  ml-12 mr-12">
            <div className="grid grid-cols-4 gap-6">
              {badges.map((badge) => (
                <div>
                  <div className="max-w-64 p-6 border-zinc-50/50 border-2 rounded-lg">
                    <h4 className="text-gray-300 text-base font-bold uppercase tracking-wide h-20 ">
                      {badge.certificateTitle}
                    </h4>
                    <div>
                      <img
                        className="w-full m-auto"
                        src={`./${badge.image}.png`}
                      />
                    </div>
                    <p className="text-gray-300 text-xs mt-4">
                      {badge.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <h3 className="text-gray-300 text-lg font-bold mt-24 uppercase tracking-wide">
              AWS Abschlussbescheinigung
            </h3>
            <div className="mt-12 mb-12">
              <div className="grid grid-cols-4 gap-6">
                {certifications.map((certification) => (
                  <div className="max-w-64 p-6 border-zinc-50/50 border-2 rounded-lg bg-zinc-50/30">
                    <h4 className="text-gray-300 text-base font-bold uppercase tracking-wide  h-20 ">
                      {certification.certificateTitle}
                    </h4>
                    <div className=" w-max m-auto p-4">
                      <img
                        className=" h-12"
                        src={`./${certification.image}.png`}
                      />
                    </div>
                    <p className="text-gray-300 text-xs mt-4">
                      {certification.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
